import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BreadCumb, DataTables, NavBar, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import $ from "jquery";
import moment from "moment";

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Sistema", value: true }, //0
    { title: "Estatus", value: true }, //1
    { title: "Mod. Autorización", value: true },//2
    { title: "Doc. orígen", value: true },//3
    { title: "Usuario creador", value: true },//4
    { title: "Nota creador", value: true },//5
    { title: "Nota autorizador", value: true },//6
    { title: "Cliente", value: true },//7
    { title: "Nombre", value: true },//8
    { title: "Total", value: true },//9
    { title: "Fecha Cont.", value: true },//10
    { title: "Tiempo de fabricación", value: true },//11
    { title: "Fecha de producción", value: true },//12
    { title: "Tiempo", value: true },//13
    { title: "ID documento", value: true },//14
]

class BillingAuthorizationView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }

    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liFacturaAuth");
        let today = moment(new Date()).format('YYYYMMDD');

        let date = {
            dateInit: today,
            dateFinal: today,
        }

        await this.callDocumentsListService(date);
    }

    selectValidateSeries = (table, data, docSubType) => {
        let series = "";
        switch (table) {
            case '23':
                series = data.U_FMB_ValidateSeriesOQUT || "";
                break;
            case '17':
                series = data.U_FMB_ValidateSeriesORDR || "";
                break;
            case '15':
                series = data.U_FMB_ValidateSeriesODLN || "";
                break;
            case '13':
                if (docSubType === "--") {
                    series = data.U_FMB_ValidateSeriesOINV || "";
                } else {
                    series = data.U_FMB_ValidateSeriesDN || "";
                }
                break;
            case '203':
                series = data.U_FMB_ValidateSeriesODPI || "";
                break;
            case '16':
                series = data.U_FMB_ValidateSeriesORDN || "";
                break;
            case '18':
                if (docSubType === "--") {
                    series = data.U_FMB_ValidateSeriesOPCH || "";
                } else {
                    series = data.U_FMB_ValidateSeriesDM || "";
                }
                break;
            case '19':
                series = data.U_FMB_ValidateSeriesORPC || "";
                break;
            case '24':
                series = data.U_FMB_ValidateSeriesORCT || "";
                break;
            case '21':
                series = data.U_FMB_ValidateSeriesORPD || "";
                break;
            case '67':
                series = data.U_FMB_ValidateSeriesOWTR || "";
                break;
            case '14':
                series = data.U_FMB_ValidateSeriesORIN || "";
                break;
            case '1250000001':
                series = data.U_FMB_ValidateSeriesOWTQ || "";
                break;
            case '59':
                series = data.U_FMB_ValidateSeriesOIGN || "";
                break;
            case '60':
                series = data.U_FMB_ValidateSeriesOIGE || "";
                break;
            case '22':
                series = data.U_FMB_ValidateSeriesOPOR || "";
                break;
            case '204':
                series = data.U_FMB_ValidateSeriesODPO || "";
                break;
            case '20':
                series = data.U_FMB_ValidateSeriesOPDN || "";
                break;
            case '1470000113':
                series = data.U_FMB_ValidateSeriesOPRQ || "";
                break;
            case '162':
                series = data.U_FMB_ValidateSeriesOMRV || "";
                break;
            case '540000006':
                series = data.U_FMB_ValidateSeriesOPQT || "";
                break;
            default:
                series = "";
        }

        return { series }
    };

    callDocumentsListService = async newDate => {
        const { enableSpinner } = this.props;


        let docType = $('#selectDocTypeDocumentSearch').val();
        let docType2 = $('#selectDocTypeDocumentSearch2').val();

        let isInvoice = false;
        let isdebitNote = "--";

        if (docType.toString() === '13' || docType === '13DN' || docType === '18DM') {
            isInvoice = true;
        }

        if (docType === '13DN') {
            isdebitNote = "DN";
            docType = '13'
        }

        if (docType === '18DM') {
            isdebitNote = "DM";
            docType = '18'
        }

        const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || {};
        const data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            docSubType: isdebitNote,
            docSubTypeDraft: docType,
            user_Email: user.E_Mail,
            table: "OWDD",
            authorizedFilter: docType2,
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--'
        };

        let invoiceListResponse;
        enableSpinner(true);
        $('#btnAuthorization').hide();
        if (isInvoice) {
            invoiceListResponse = await apiClient.getDocumentsListInvoice(data);
        } else {
            invoiceListResponse = await apiClient.getDocumentsList(data);
        }
        enableSpinner(false);
        $('#btnAuthorization').show();

        if (invoiceListResponse.status === SERVICE_RESPONSE.SUCCESS) {

            const dataSerie = {
                docType: docType,
                docSubType: isdebitNote
            };

            enableSpinner(true);
            const seriesResponse = await apiClient.getSeries(dataSerie);
            enableSpinner(false);
            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
            let ValidateSeries = this.selectValidateSeries(docType, user, isdebitNote);

            if (!user || ValidateSeries.series === "") {
                this.setState({
                    data: [],
                });
                return;
            }
            let seriesUsers = ValidateSeries.series.split("|");
            let newArraySeries = [];

            for (let index = 0; index < seriesUsers.length; index++) {
                const serieUser = seriesUsers[index];
                for (let index = 0; index < seriesResponse.data.length; index++) {
                    const serieResponse = seriesResponse.data[index];
                    if (isInvoice) {
                        if (Number(serieResponse.Series) === Number(serieUser) && Number(serieResponse.ObjectCode) === 13 && serieResponse.DocSubType === '--') {
                            newArraySeries.push(serieResponse);
                        }
                        if (Number(serieResponse.Series) === Number(serieUser) && Number(serieResponse.ObjectCode) === 18 && serieResponse.DocSubType === 'DM') {
                            newArraySeries.push(serieResponse);
                        }
                    } else {
                        if (Number(serieResponse.Series) === Number(serieUser)) {
                            newArraySeries.push(serieResponse);
                        }
                    }
                }
            }

            if (newArraySeries.length === 0) {
                return;
            }

            let newDocumentsfilterSeries = [];
            for (let index = 0; index < invoiceListResponse.data.length; index++) {
                const document = invoiceListResponse.data[index];
                for (let index = 0; index < newArraySeries.length; index++) {
                    const serie = newArraySeries[index];
                    if (String(document.SeriesCode) === String(serie.Series)) {
                        newDocumentsfilterSeries.push(document);
                    }
                }
            }


            this.setState({
                data: newDocumentsfilterSeries,
            });
            return;
        } else {
            this.setState({
                data: [],
            });
        }

        //showAlert({type: 'error', message: invoiceListResponse.message});

    }

    searchDocuments = async date => {
        await this.callDocumentsListService(date);
    };

    handleRemarks2 = (event, id, wtmName) => {
        const { data } = this.state;
        let array = data;
        let char = event.nativeEvent.target.value;
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if (element.DocEntryODRF === id && element.WtmName === wtmName) {
                element.Remarks = char || '';
            }
        }
        this.setState({
            data: array,
        });
        return;
    }

    handleRemarks = async (event, id, wtmName) => {
        await this.handleRemarks2(event, id, wtmName);
    }

    handleStatusAuthorization = (event, id, wtmName) => {
        const { data } = this.state;
        let array = data;
        let char = event.nativeEvent.target.value;
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if (element.DocEntryODRF === id && element.WtmName === wtmName) {
                element.Status = char;
            }
        }
        this.setState({
            data: array,
        });
        return;
    }
    render() {
        const { headers, data, _user } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={'DOCUMENTOS POR AUTORIZAR'} url1={'#'} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <span id="linkOrdProv" className="text-muted">
                            &nbsp;DOCUMENTOS POR AUTORIZAR
                        </span>
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"invoiceAuthorization"}
                        data={data}
                        search={this.searchDocuments}
                        handleRemarks={this.handleRemarks}
                        handleStatusAuthorization={this.handleStatusAuthorization}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BillingAuthorizationView);


